module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("chapter 2")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_vm._v("Cow")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("The")]), _vm._v(" reason we have all been loaded into the old bus is that we spend part of every summer with Aunt Frankie in North Dakota. Everyone calls her Frankie. Her name is Francesca, but she says that is pretentious. That is the first time I ever heard the word “pretentious,” and I’ve ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("been looking for a time to use it ever since. It is much too long for a poem.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Frankie, who Mama says is as “old as time,” lives far out in the middle of the universe. She lives by a big river that floods in the rainy season. It is now the rainy season, and Boots says it will flood while we’re there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Frankie will need our help even though she doesn’t think so,” says Boots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is so stubborn,” my mother complains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boots looks at me in the rearview mirror. It is like looking into my eyes, we look so much the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who else is stubborn?” he asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mama!” says Gracie.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Frankie has a few milking cows she milks every day, but leases most of the higher meadowland for other people’s cattle.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There are few trees, no mountains, just miles and miles of prairie grass and gophers and sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frankie’s house is the house where Mama grew up. Mama loved it and hated it at the same time. She always cries when we get there and cries when we leave. Maybe one day I’ll understand that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sounds like ‘the birdies fly away and come back home’ to me,” I once said to Boots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re very right,” he said, peering at me as if I’d said something important.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("At dusk we find a place to stop for the night. It is a state park hill with an open field, bordered by a farmland fence. Mama lets Sofia, Ella, and Nickel out of their crates and spreads chicken feed on the ground for them. They flap their wings and mosey around, eating and strutting. My mother and father get out their chairs and their small stove. They set up their tent near a tree. Gracie, Teddy, and I always sleep in the car beds, Teddy in the middle. Mama and Boots could sleep in the bus, but they love their small domed tent.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why can’t we stay in a motel?” Gracie asks. “Trini’s family goes to a motel with a pool and dining room and minia­ture golf course where a little volcano goes off if you get a hole in one.”")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("I know what Boots is about to say. I’ve heard it many times. I’ve even written a poem about it. Gracie has heard it before too, but she is young enough to think the answer may change when she asks to stay in a motel. She’ll know better one day.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "poemb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Motel Room")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Where’s the river?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Where’s the sky?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Can’t see the clouds—")])]), _vm._v(" "), _c('p', {
    staticClass: "poemb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Or bluebirds fly by.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boots waves his arm.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“In a motel you wouldn’t have this great view,” says Boots. “You’d have four ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("walls with boring paintings.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe a motel would have a pool,” said Gracie.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Maybe we’ll find a river,” said Boots.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Can’t smell the flowers,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Can’t smell the sea—")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Four walls and bad art")])]), _vm._v(" "), _c('p', {
    staticClass: "poemb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Is all that you’ll see.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I take Teddy for a walk in the mea­dow. He reaches up and takes my hand with his tiny hand. His hand is warm. He wears red sneakers and a faded T-shirt with a green fish on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly Teddy stops. He is staring at something. He points.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cow,” he says.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Teddy, you said cow!”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As far as I know Teddy has never said cow. But he says it as clear as light. He says it again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mama!” I shout. “Boots! Teddy said cow!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mama waves. Boots and Gracie come quickly across the field and look where Teddy is pointing. Far off, at the fence, stands a cow. It is a kind of cow I’ve never seen. Ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, my.” Boots’s voice is strange. “Oh, my,” he repeats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cow,” says Teddy again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, my,” says Boots again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I feel like I’m in a strange echo chamber.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Boots starts to walk toward the fence, then comes back to scoop Teddy up in his arms. He beckons for us to follow.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At the fence is a very large cow. She is beautiful and black, with a wide white stripe around the middle of her. My breath catches. Maybe Boots is right after all. That he couldn’t write anything more beautiful than a cow. Maybe no one can.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cow,” says Teddy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that,” I say, then I laugh because it is Teddy I’m answering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dutch Belted,” says Gracie. “Boots’s cows are mostly Holsteins or Guernseys,” she tells me.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Gracie has a chart at home of all the cow breeds. She opens her notebook and ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("takes out a pen. She begins to draw the cow.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve never seen one,” says Boots. He puts his hand across the fence and the cow moves back quickly. Then, after a moment, she comes back so Boots can rub her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beautiful,” says Boots. “Beautiful Dutch Belted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cow,” says Teddy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Teddy,” says Boots. “Dutch Belted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teddy reaches his hand over the fence and rubs the cow’s head, imitating Boots. The cow’s tongue comes out, long and rough, making Teddy jump.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The sun goes down behind the faraway line of trees. Two more Dutch ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Belted cows move toward us, probably hoping for grain.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cow,” whispers Teddy, putting his arm around Boots’s neck.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "39",
      "src": "images/bird.png",
      "width": "80"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Nighttime. Grace is sleeping. She is always first to go to sleep. There are stars out in the black sky and I can see the glow of the lantern light in Mama and Boots’s tent. There is a slice of moon above the trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“See?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("It is Teddy’s little voice next to me. That’s the only part of my name, Lucy, that he can say—the “see” of Lucy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Teddy,” I whisper.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Cow,” he says.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Cow,” I whisper.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("His eyes gleam in the dark. I know he’s ")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("going to sing now. And he does. He sings the song perfectly, all the la la’s in tune. I hear the words in my head.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "poemc"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Fly away, fly away,")])]), _vm._v(" "), _c('p', {
    staticClass: "poemcb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("All the birdies fly away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I reach over and take his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("And we sleep.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726606ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 69
// module chunks = 0